module.exports = __webpack_public_path__ + "static/media/mobile-image-dcom.1b8edddf.png";